(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v3-design-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = window.Shopify?.routes?.root || '/';
    const liveRegion = () => document.querySelector('[data-live-region]');
    const translationsNode = document.querySelector('[data-gc-translations]');
    const translations = translationsNode ? JSON.parse(translationsNode.textContent) : {};
    let lastCartTrigger = null;
    let lastMenuTrigger = null;
    let cartChangePending = false;

    const announce = (message) => {
      const region = liveRegion();
      if (!region) return;
      region.textContent = '';
      window.setTimeout(() => { region.textContent = message; }, 40);
    };

    const updateCartCounts = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = count;
        element.hidden = false;
      });
    };

    const cartDialog = () => document.querySelector('[data-cart-dialog]');

    const openCart = () => {
      const dialog = cartDialog();
      if (!dialog) return;
      const menu = document.querySelector('[data-menu-dialog][open]');
      if (menu) menu.close();
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-cart-close]')?.focus();
    };

    const closeCart = () => {
      const dialog = cartDialog();
      if (!dialog?.open) return;
      dialog.close();
      lastCartTrigger?.focus();
    };

    const openMenu = (trigger) => {
      const menu = document.querySelector('[data-menu-dialog]');
      if (!menu) return;
      lastMenuTrigger = trigger;
      if (!menu.open) menu.showModal();
      menu.querySelector('[data-menu-close]')?.focus();
    };

    const closeMenu = () => {
      const menu = document.querySelector('[data-menu-dialog]');
      if (!menu?.open) return;
      menu.close();
      lastMenuTrigger?.focus();
    };

    const showCartError = (message) => {
      const error = document.querySelector('[data-cart-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    };

    const refreshCart = async (openAfter = true) => {
      const currentDialog = cartDialog();
      const note = currentDialog?.querySelector('textarea[name="note"]');
      const noteValue = note?.value;
      const noteWasOpen = note?.closest('details')?.open || false;
      const [sectionResponse, cartResponse] = await Promise.all([
        fetch(`${root}?section_id=cart-drawer`, { credentials: 'same-origin', headers: { Accept: 'text/html' } }),
        fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      ]);
      if (!sectionResponse.ok || !cartResponse.ok) throw new Error(translations.cartRefreshError || 'Cart unavailable.');
      const html = await sectionResponse.text();
      const cart = await cartResponse.json();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('#shopify-section-cart-drawer');
      const current = document.querySelector('#shopify-section-cart-drawer');
      const incomingDialog = parsed.querySelector('[data-cart-dialog]');
      if (incoming && current) {
        current.replaceWith(incoming);
      } else if (incomingDialog && currentDialog) {
        currentDialog.replaceWith(incomingDialog);
      }
      if (noteValue !== undefined) {
        const refreshedNote = cartDialog()?.querySelector('textarea[name="note"]');
        if (refreshedNote) {
          refreshedNote.value = noteValue;
          const details = refreshedNote.closest('details');
          if (details && noteWasOpen) details.open = true;
        }
      }
      updateCartCounts(cart.item_count);
      if (openAfter) openCart();
      return cart;
    };

    const buttonLabel = (button) => button?.querySelector('[data-button-label]') || button?.querySelector('span') || button;

    const setButtonState = (button, state) => {
      if (!button) return;
      const label = buttonLabel(button);
      if (!button.dataset.defaultLabel) button.dataset.defaultLabel = label.textContent.trim();
      if (!button.dataset.defaultDisabled) button.dataset.defaultDisabled = String(button.disabled);
      button.disabled = state === 'loading' || button.dataset.defaultDisabled === 'true';
      if (state === 'loading') label.textContent = button.dataset.loadingLabel || translations.adding || '';
      if (state === 'success') label.textContent = button.dataset.successLabel || translations.added || '';
      if (state === 'default') {
        label.textContent = button.dataset.defaultLabel;
        button.disabled = button.dataset.defaultDisabled === 'true';
      }
    };

    const productButtons = (form) => {
      const buttons = [...form.querySelectorAll('[type="submit"][name="add"]')];
      if (form.id) {
        const escapedId = window.CSS?.escape ? window.CSS.escape(form.id) : form.id;
        buttons.push(...document.querySelectorAll(`[type="submit"][name="add"][form="${escapedId}"]`));
      }
      return [...new Set(buttons)];
    };

    const showProductError = (form, message = '') => {
      const scope = form.closest('[data-product-section], [data-product-card]') || form;
      const error = scope.querySelector('[data-product-error]');
      if (error) error.textContent = message;
    };

    const addToCart = async (form) => {
      const buttons = productButtons(form);
      buttons.forEach((button) => setButtonState(button, 'loading'));
      showProductError(form);
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || translations.addError || 'Unable to add item.');
      buttons.forEach((button) => setButtonState(button, 'success'));
      await refreshCart(true);
      announce(translations.addedAnnouncement || 'Added to cart.');
      window.setTimeout(() => buttons.forEach((button) => setButtonState(button, 'default')), 1400);
    };

    const changeCartLine = async (key, quantity) => {
      if (cartChangePending) return;
      cartChangePending = true;
      const dialog = cartDialog();
      const scrollArea = document.querySelector('[data-cart-scroll]');
      const controls = [...(dialog?.querySelectorAll('[data-cart-change], [data-cart-quantity-input], [name="checkout"]') || [])];
      const controlStates = controls.map((control) => [control, control.disabled]);
      const error = dialog?.querySelector('[data-cart-error]');
      if (error) error.hidden = true;
      scrollArea?.setAttribute('aria-busy', 'true');
      controls.forEach((control) => { control.disabled = true; });
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || translations.cartUpdateError || 'Unable to update cart.');
        await refreshCart(dialog?.open || false);
        announce(translations.updatedAnnouncement || 'Cart updated.');
      } finally {
        scrollArea?.removeAttribute('aria-busy');
        controlStates.forEach(([control, disabled]) => { control.disabled = disabled; });
        cartChangePending = false;
      }
    };

    const handleCartChangeError = (error, input) => {
      if (input?.isConnected) input.value = input.defaultValue;
      showCartError(error.message);
      announce(error.message);
    };

    const submitCartQuantity = (input, adjustment = 0) => {
      if (!input || cartChangePending) return;
      const minimum = Number(input.dataset.min) || 1;
      let quantity = Number(input.value);
      input.min = quantity === 0 ? '0' : String(minimum);
      if (!input.reportValidity()) return;
      if (!Number.isSafeInteger(quantity)) {
        handleCartChangeError(new Error(translations.cartUpdateError || 'Unable to update cart.'), input);
        return;
      }
      if (adjustment) {
        quantity = quantity === 0 && adjustment > 0 ? minimum : quantity + adjustment;
        if (quantity < minimum) quantity = 0;
        input.value = quantity;
        input.min = quantity === 0 ? '0' : String(minimum);
        if (!input.reportValidity()) {
          input.value = input.defaultValue;
          return;
        }
      }
      if (quantity === Number(input.defaultValue)) return;
      changeCartLine(input.dataset.key, quantity).catch((error) => handleCartChangeError(error, input));
    };

    const updateVariant = (select) => {
      const option = select.selectedOptions[0];
      const section = select.closest('[data-product-section]');
      if (!option || !section) return;
      const available = option.dataset.variantAvailable === 'true';
      const formattedPrice = option.dataset.variantPriceFormatted || '';
      const formattedComparePrice = option.dataset.variantCompareAtPriceFormatted || '';

      section.querySelectorAll('[data-product-price], [data-sticky-product-price]').forEach((price) => {
        price.textContent = price.dataset.priceLabel ? `${price.dataset.priceLabel} · ${formattedPrice}` : formattedPrice;
      });

      section.querySelectorAll('[data-product-compare-price]').forEach((price) => {
        price.textContent = formattedComparePrice;
        price.hidden = !formattedComparePrice;
      });

      section.querySelectorAll('[data-product-submit], [data-sticky-product-submit]').forEach((button) => {
        const label = buttonLabel(button);
        const nextLabel = available
          ? `${translations.addToCart || 'Add to cart'}${button.hasAttribute('data-product-submit') && !button.hasAttribute('data-hide-price') ? ` · ${formattedPrice}` : ''}`
          : translations.soldOut || 'Sold out';
        label.textContent = nextLabel;
        button.disabled = !available;
        button.dataset.defaultDisabled = String(!available);
        button.dataset.defaultLabel = nextLabel;
      });

      showProductError(select.closest('form') || section.querySelector('[data-ajax-product-form]'));

      if (option.dataset.featuredMediaId && window.matchMedia('(max-width: 749px)').matches) {
        const media = section.querySelector(`[data-media-id="${option.dataset.featuredMediaId}"]`);
        const galleryTrack = media?.closest('[data-product-gallery]')?.querySelector('.gc-product-gallery__list');
        if (media && galleryTrack) {
          galleryTrack.scrollTo({
            left: media.offsetLeft - galleryTrack.offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };

    const normaliseVariantOptionLabels = (select) => {
      select.querySelectorAll('option').forEach((option) => {
        const title = option.dataset.variantTitle?.trim();
        if (!title) return;
        const price = option.dataset.variantPriceFormatted?.trim();
        const availability = option.dataset.variantAvailable === 'true'
          ? ''
          : ` — ${translations.soldOut || 'Sold out'}`;
        const label = `${title}${price ? ` — ${price}` : ''}${availability}`;
        if (option.textContent.trim() !== label) option.textContent = label;
        if (option.label !== label) option.label = label;
      });
    };

    const setupVariantOptionGuards = (scope = document) => {
      scope.querySelectorAll('[data-variant-select]').forEach((select) => {
        normaliseVariantOptionLabels(select);
        if (select.dataset.variantLabelGuard === 'true' || !('MutationObserver' in window)) return;
        select.dataset.variantLabelGuard = 'true';
        const observer = new MutationObserver(() => normaliseVariantOptionLabels(select));
        observer.observe(select, {
          attributes: true,
          attributeFilter: ['label'],
          characterData: true,
          childList: true,
          subtree: true
        });
      });
    };

    const reveal = (scope = document) => {
      const items = scope.querySelectorAll('[data-reveal]:not(.is-observed)');
      if (!items.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: .08 });
      items.forEach((item) => {
        item.classList.add('is-observed');
        observer.observe(item);
      });
    };

    const setupStickyProductBar = (scope = document) => {
      scope.querySelectorAll('[data-product-section]').forEach((section) => {
        if (section.dataset.stickyReady) return;
        section.dataset.stickyReady = 'true';
        const bar = section.querySelector('[data-sticky-product-bar]');
        const primary = section.querySelector('[data-product-submit]');
        if (!bar || !primary) return;
        if (!('IntersectionObserver' in window)) {
          bar.dataset.visible = 'true';
          return;
        }
        const observer = new IntersectionObserver(([entry]) => {
          bar.dataset.visible = String(!entry.isIntersecting);
        }, { threshold: .1 });
        observer.observe(primary);
      });
    };

    const initialise = (scope = document) => {
      reveal(scope);
      setupStickyProductBar(scope);
      setupVariantOptionGuards(scope);
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-ajax-product-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form).catch((error) => {
        productButtons(form).forEach((button) => setButtonState(button, 'default'));
        showProductError(form, error.message);
        announce(error.message);
      });
    });

    document.addEventListener('change', (event) => {
      const cartQuantity = event.target.closest('[data-cart-quantity-input]');
      if (cartQuantity) {
        submitCartQuantity(cartQuantity);
        return;
      }

      const variantSelect = event.target.closest('[data-variant-select]');
      if (variantSelect) {
        updateVariant(variantSelect);
        return;
      }

      if (event.target.matches('[data-facet-form] select[name="sort_by"]')) {
        event.target.form?.requestSubmit();
      }
    });

    document.addEventListener('keydown', (event) => {
      const cartQuantity = event.target.closest('[data-cart-quantity-input]');
      if (event.key === 'Enter' && cartQuantity) {
        event.preventDefault();
        submitCartQuantity(cartQuantity);
      }
    });

    document.addEventListener('pointerdown', (event) => {
      const change = event.target.closest('[data-cart-change]');
      const focusedQuantity = document.activeElement?.closest('[data-cart-quantity-input]');
      if (change && focusedQuantity?.closest('[data-cart-line]') === change.closest('[data-cart-line]')) {
        event.preventDefault();
      }
    });

    document.addEventListener('click', (event) => {
      const confirmControl = event.target.closest('[data-confirm-message]');
      if (confirmControl && !window.confirm(confirmControl.dataset.confirmMessage)) {
        event.preventDefault();
        return;
      }

      const openTrigger = event.target.closest('[data-cart-open]');
      if (openTrigger && cartDialog()) {
        event.preventDefault();
        lastCartTrigger = openTrigger;
        openCart();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        closeCart();
        return;
      }

      const dialog = event.target.closest('[data-cart-dialog]');
      if (dialog && event.target === dialog) {
        closeCart();
        return;
      }

      const menuOpen = event.target.closest('[data-menu-open]');
      if (menuOpen) {
        event.preventDefault();
        openMenu(menuOpen);
        return;
      }

      if (event.target.closest('[data-menu-close]')) {
        closeMenu();
        return;
      }

      const menuDialog = event.target.closest('[data-menu-dialog]');
      if (menuDialog && event.target === menuDialog) {
        closeMenu();
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      if (change) {
        event.preventDefault();
        const input = change.closest('[data-cart-line]')?.querySelector('[data-cart-quantity-input]');
        if (change.dataset.quantityStep) {
          submitCartQuantity(input, Number(change.dataset.quantityStep));
        } else {
          changeCartLine(change.dataset.key, Number(change.dataset.quantity)).catch((error) => handleCartChangeError(error, input));
        }
      }
    });

    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise());
    } else {
      initialise();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
